export default __webpack_public_path__ + "static/media/deleteAccountStep1.0ab86f42.png";